import {Stack} from 'shells/layout/stack/stack';
import {Percentage} from 'shells/percentage/percentage';
import {TwoLineInfo} from 'shells/two-line-info/two-line-info';
import {Body} from 'shells/typography/body';

interface Props {
    totalSentCount: number | null | undefined;
    openRate: number | null | undefined;
    clickRate: number | null | undefined;
    replyRate: number | null | undefined;
}

export type EmailEngagementSection = 'Emails sent' | 'Open rate' | 'Click rate' | 'Reply rate';

export function PeepEmailStats(props: Props) {
    const getPercentageSection = (
        label: EmailEngagementSection,
        value: number | null | undefined
    ) => {
        return (
            <TwoLineInfo
                key={label}
                label={
                    <Body size='small' isBold={true}>
                        {label}
                    </Body>
                }
                rightAligned={true}
            >
                <Body size='large' isBold={true}>
                    {/* @ts-expect-error */}
                    <Percentage value={value} />
                </Body>
            </TwoLineInfo>
        );
    };

    return (
        <Stack spacing={8} isHorizontal isFullWidth justifyContent='space-between'>
            <TwoLineInfo
                label={
                    <span data-tip='All emails sent from inside of Nutshell that include open or click tracking'>
                        <Body size='small' isBold={true}>
                            Emails sent
                        </Body>
                    </span>
                }
                rightAligned={true}
            >
                <Body size='large' isBold={true}>
                    {props.totalSentCount || 0}
                </Body>
            </TwoLineInfo>
            {getPercentageSection('Open rate', props.openRate)}
            {getPercentageSection('Click rate', props.clickRate)}
            {getPercentageSection('Reply rate', props.replyRate)}
        </Stack>
    );
}
